
// this file is generated by the transinterface.js
enum Localisation {
	'emptyString' = 'emptyString', 
	'File.CannotDownloadThisFile' = 'File.CannotDownloadThisFile', 
	'File.CannotViewinBrowser' = 'File.CannotViewinBrowser', 
	'File.Download' = 'File.Download', 
	'File.Downloaded' = 'File.Downloaded', 
	'File.Downloading' = 'File.Downloading', 
	'File.File' = 'File.File', 
	'File.FileIcon' = 'File.FileIcon', 
	'File.NoFileFound' = 'File.NoFileFound', 
	'File.NoFileFoundExplanatory' = 'File.NoFileFoundExplanatory', 
	'File.OpenFile' = 'File.OpenFile', 
	'File.SaveFileToDevice' = 'File.SaveFileToDevice', 
	'File.UploadingFilesPlural' = 'File.UploadingFilesPlural', 
	'File.UploadingFilesSingular' = 'File.UploadingFilesSingular', 
	'File.UploadProgressMultiple' = 'File.UploadProgressMultiple', 
	'File.FinishingUp' = 'File.FinishingUp', 
	'General.Address' = 'General.Address', 
	'General.AccessNotGranted' = 'General.AccessNotGranted', 
	'General.AcknowledgementCompetitionFull' = 'General.AcknowledgementCompetitionFull', 
	'General.AcknowledgementCompetitionUnspecified' = 'General.AcknowledgementCompetitionUnspecified', 
	'General.AcknowledgementEventFull' = 'General.AcknowledgementEventFull', 
	'General.AcknowledgementEventUnspecified' = 'General.AcknowledgementEventUnspecified', 
	'General.AcknowledgementNoPermission' = 'General.AcknowledgementNoPermission', 
	'General.AcknowledgementNoPermissionContactAdmin' = 'General.AcknowledgementNoPermissionContactAdmin', 
	'General.AreYouSure' = 'General.AreYouSure',
	'General.BackToAppLibrary' = 'General.BackToAppLibrary', 
	'General.Call' = 'General.Call', 
	'General.Cancel' = 'General.Cancel', 
	'General.ContactSupport' = 'General.ContactSupport', 
	'General.ContentPreviewForX' = 'General.ContentPreviewForX', 
	'General.ContentPreviewMissingForX' = 'General.ContentPreviewMissingForX', 
	'General.ContentPreviewVideoForX' = 'General.ContentPreviewVideoForX', 
	'General.Department' = 'General.Department', 
	'General.Edit' = 'General.Edit',
	'General.Email' = 'General.Email', 
	'General.EmailAddress' = 'General.EmailAddress', 
	'General.EmailSent' = 'General.EmailSent', 
	'General.EnterThisCompetition' = 'General.EnterThisCompetition', 
	'General.ExternalAuthProviderFailure' = 'General.ExternalAuthProviderFailure', 
	'General.ExternalAuthProviderRedirectMessage' = 'General.ExternalAuthProviderRedirectMessage', 
	'General.FilterDate' = 'General.FilterDate', 
	'General.GoThereNow' = 'General.GoThereNow',
	'General.Input' = 'General.Input', 
	'General.InvalidPasswordEntry' = 'General.InvalidPasswordEntry', 
	'General.LockerBreadcrumb' = 'General.LockerBreadcrumb', 
	'General.LinkCopied' = 'General.LinkCopied', 
	'General.MarkedAsCompleted' = 'General.MarkedAsCompleted', 
	'General.MainMenu' = 'General.MainMenu', 
	'General.Mobile' = 'General.Mobile', 
	'General.Name' = 'General.Name',
	'General.Next' = 'General.Next', 
	'General.NoCancel' = 'General.NoCancel', 
	'General.NoInternetConnection' = 'General.NoInternetConnection', 
	'General.Ok' = 'General.Ok', 
	'General.OpenMenu' = 'General.OpenMenu', 
	'General.Password' = 'General.Password', 
	'General.PageNotFound' = 'General.PageNotFound', 
	'General.PageNotFoundDetails' = 'General.PageNotFoundDetails', 
	'General.PostMarkedAsCompleted' = 'General.PostMarkedAsCompleted', 
	'General.RSVPToThisEvent' = 'General.RSVPToThisEvent', 
	'General.RefreshTokenExpiry' = 'General.RefreshTokenExpiry', 
	'General.Remove' = 'General.Remove', 
	'General.SelectAWorkspace' = 'General.SelectAWorkspace', 
	'General.SelectCountryCode' = 'General.SelectCountryCode', 
	'General.Settings' = 'General.Settings', 
	'General.ShareThisPost' = 'General.ShareThisPost', 
	'General.SomethingWentWrong' = 'General.SomethingWentWrong', 
	'General.Telephone' = 'General.Telephone', 
	'General.TheCompetitionIsNowClosed' = 'General.TheCompetitionIsNowClosed', 
	'General.ThisEventIsNowClosed' = 'General.ThisEventIsNowClosed', 
	'General.ThisEventIsNowFull' = 'General.ThisEventIsNowFull', 
	'General.ThisPostNeedsYourAttention' = 'General.ThisPostNeedsYourAttention', 
	'General.ToContent' = 'General.ToContent', 
	'General.Undo' = 'General.Undo', 
	'General.UnexpectedError' = 'General.UnexpectedError', 
	'General.Username' = 'General.Username', 
	'General.Website' = 'General.Website', 
	'General.YesDelete' = 'General.YesDelete', 
	'General.YoureGoingToThisEvent' = 'General.YoureGoingToThisEvent', 
	'General.YouveEnteredThisCompetition' = 'General.YouveEnteredThisCompetition', 
	'General.ViewInNewWindow' = 'General.ViewInNewWindow', 
	'General.ViewContent' = 'General.ViewContent', 
	'General.Save' = 'General.Save', 
	'General.Post' = 'General.Post', 
	'General.Back' = 'General.Back', 
	'General.ReturnToPrevious' = 'General.ReturnToPrevious', 
	'General.Locker' = 'General.Locker', 
	'General.PeopleDirectory' = 'General.PeopleDirectory', 
	'General.Notifications' = 'General.Notifications', 
	'General.Profile' = 'General.Profile', 
	'General.AppLibrary' = 'General.AppLibrary', 
	'General.Logout' = 'General.Logout', 
	'General.MorePeople' = 'General.MorePeople', 
	'General.ViewPost' = 'General.ViewPost', 
	'General.ViewList' = 'General.ViewList', 
	'General.ViewWebpage' = 'General.ViewWebpage', 
	'General.ViewImage' = 'General.ViewImage', 
	'General.WatchVideo' = 'General.WatchVideo', 
	'General.OpenDocument' = 'General.OpenDocument', 
	'General.ViewContact' = 'General.ViewContact', 
	'General.ViewRss' = 'General.ViewRss', 
	'General.PlayAudio' = 'General.PlayAudio', 
	'General.XPeople' = 'General.XPeople', 
	'General.XSelected' = 'General.XSelected', 
	'General.LikedBy' = 'General.LikedBy', 
	'General.PhoneNumberRemoved' = 'General.PhoneNumberRemoved', 
	'General.PasswordsDoNotMatch' = 'General.PasswordsDoNotMatch', 
	'General.PasswordCriteria' = 'General.PasswordCriteria', 
	'General.PasswordShouldContain' = 'General.PasswordShouldContain', 
	'General.SaveChanges' = 'General.SaveChanges', 
	'General.MinimumCharacters' = 'General.MinimumCharacters', 
	'General.MaximumCharacters' = 'General.MaximumCharacters', 
	'General.Required' = 'General.Required', 
	'General.MustBeNumeric' = 'General.MustBeNumeric', 
	'General.TextOnly' = 'General.TextOnly', 
	'General.EmailInvalid' = 'General.EmailInvalid', 
	'General.SelectAnOption' = 'General.SelectAnOption', 
	'General.EnterSomeText' = 'General.EnterSomeText', 
	'General.OptionalImageCaption' = 'General.OptionalImageCaption', 
	'General.AddImageCaption' = 'General.AddImageCaption', 
	'General.AddImage' = 'General.AddImage', 
	'General.AddFile' = 'General.AddFile', 
	'General.Date' = 'General.Date', 
	'General.Filter' = 'General.Filter', 
	'General.Yes' = 'General.Yes', 
	'General.No' = 'General.No', 
	'General.AllDay' = 'General.AllDay', 
	'General.Search' = 'General.Search', 
	'General.ClearFilters' = 'General.ClearFilters', 
	'General.SaveSettings' = 'General.SaveSettings', 
	'General.ShowResults' = 'General.ShowResults', 
	'General.MarkAllAsRead' = 'General.MarkAllAsRead', 
	'General.AllCaughtUp' = 'General.AllCaughtUp', 
	'General.MarkAllNotificationsAsRead' = 'General.MarkAllNotificationsAsRead', 
	'General.UnreadNotifications' = 'General.UnreadNotifications', 
	'General.UnreadNotificationsCount' = 'General.UnreadNotificationsCount', 
	'General.WorkspaceLoginPageTitle' = 'General.WorkspaceLoginPageTitle', 
	'General.LoginPageTitle' = 'General.LoginPageTitle', 
	'General.ForgotPasswordPageTitle' = 'General.ForgotPasswordPageTitle', 
	'General.RegistrationPageTitle' = 'General.RegistrationPageTitle', 
	'General.RegisterNewPasswordPageTitle' = 'General.RegisterNewPasswordPageTitle', 
	'General.ShareOnFacebook' = 'General.ShareOnFacebook', 
	'General.ShareOnX' = 'General.ShareOnX', 
	'General.LinkedIn' = 'General.LinkedIn', 
	'General.CopyLinkToShare' = 'General.CopyLinkToShare', 
	'General.ViewShareMenu' = 'General.ViewShareMenu', 
	'General.CloseMenu' = 'General.CloseMenu', 
	'General.ToggleCarouselItem' = 'General.ToggleCarouselItem', 
	'General.PreviousCarousel' = 'General.PreviousCarousel', 
	'General.NextCarousel' = 'General.NextCarousel', 
	'General.StartCarousel' = 'General.StartCarousel', 
	'General.PauseCarousel' = 'General.PauseCarousel', 
	'General.DownloadVideo' = 'General.DownloadVideo', 
	'General.XOfX' = 'General.XOfX', 
	'General.SkipToContentOnThisPage' = 'General.SkipToContentOnThisPage', 
	'General.WorkspaceLogo' = 'General.WorkspaceLogo', 
	'General.CloseModal' = 'General.CloseModal', 
	'General.SkipToTop' = 'General.SkipToTop', 
	'General.XAutoCompleteSuggestions' = 'General.XAutoCompleteSuggestions', 
	'General.DownloadContact' = 'General.DownloadContact', 
	'General.ClearSearch' = 'General.ClearSearch', 
	'General.ViewXUsersProfile' = 'General.ViewXUsersProfile', 
	'General.About' = 'General.About', 
	'General.PrivacyPolicy' = 'General.PrivacyPolicy', 
	'General.ThisLinkOpensInANewTab' = 'General.ThisLinkOpensInANewTab', 
	'General.Chat' = 'General.Chat', 
	'General.Preview' = 'General.Preview', 
	'General.You' = 'General.You', 
	'Locker.ANewFile' = 'Locker.ANewFile', 
	'Locker.All' = 'Locker.All', 
	'Locker.AltTextNoFiles' = 'Locker.AltTextNoFiles', 
	'Locker.AltTextNewUser' = 'Locker.AltTextNewUser', 
	'Locker.AltTextUserRegistrationComplete' = 'Locker.AltTextUserRegistrationComplete', 
	'Locker.AltTextLockerIcons' = 'Locker.AltTextLockerIcons', 
	'Locker.Cancel' = 'Locker.Cancel', 
	'Locker.Clear' = 'Locker.Clear', 
	'Locker.ClearAll' = 'Locker.ClearAll', 
	'Locker.Close' = 'Locker.Close', 
	'Locker.Confirm' = 'Locker.Confirm', 
	'Locker.CreatePasscode' = 'Locker.CreatePasscode', 
	'Locker.Done' = 'Locker.Done', 
	'Locker.EmptyLocker' = 'Locker.EmptyLocker', 
	'Locker.EmptyLockerExplanatory' = 'Locker.EmptyLockerExplanatory', 
	'Locker.EnableBiometrics' = 'Locker.EnableBiometrics', 
	'Locker.EnableBiometricsExplanatory' = 'Locker.EnableBiometricsExplanatory', 
	'Locker.EnterPassword' = 'Locker.EnterPassword', 
	'Locker.EnterYourPasscode' = 'Locker.EnterYourPasscode', 
	'Locker.EnterPasswordExplanatory' = 'Locker.EnterPasswordExplanatory', 
	'Locker.FileHasBeenPutInLocker' = 'Locker.FileHasBeenPutInLocker', 
	'Locker.FilterExplanatoryTime' = 'Locker.FilterExplanatoryTime', 
	'Locker.FilterExplanatoryType' = 'Locker.FilterExplanatoryType', 
	'Locker.ForgotPasscode' = 'Locker.ForgotPasscode', 
	'Locker.ForgotPasscodeQuestion' = 'Locker.ForgotPasscodeQuestion', 
	'Locker.GetStarted' = 'Locker.GetStarted', 
	'Locker.GoodAfternoon' = 'Locker.GoodAfternoon', 
	'Locker.GoodEvening' = 'Locker.GoodEvening', 
	'Locker.GoodMorning' = 'Locker.GoodMorning', 
	'Locker.Icon' = 'Locker.Icon', 
	'Locker.IncorrectPasscode' = 'Locker.IncorrectPasscode', 
	'Locker.Locker' = 'Locker.Locker', 
	'Locker.LockerIsReady' = 'Locker.LockerIsReady', 
	'Locker.LockerIsReadyExplanatory' = 'Locker.LockerIsReadyExplanatory', 
	'Locker.MonthFilter' = 'Locker.MonthFilter', 
	'Locker.MyLocker' = 'Locker.MyLocker', 
	'Locker.NetworkError' = 'Locker.NetworkError', 
	'Locker.NoResults' = 'Locker.NoResults', 
	'Locker.Offline' = 'Locker.Offline', 
	'Locker.OpenMyLocker' = 'Locker.OpenMyLocker', 
	'Locker.PasscodeDoesNotMatch' = 'Locker.PasscodeDoesNotMatch', 
	'Locker.PasscodeResetUnavailable' = 'Locker.PasscodeResetUnavailable', 
	'Locker.PasscodeResetUnavailableExplanatory' = 'Locker.PasscodeResetUnavailableExplanatory', 
	'Locker.PasscodeSetup' = 'Locker.PasscodeSetup', 
	'Locker.PasscodeTooManyTimes' = 'Locker.PasscodeTooManyTimes', 
	'Locker.Password' = 'Locker.Password', 
	'Locker.PasswordExplanatory' = 'Locker.PasswordExplanatory', 
	'Locker.ReEnterPasscode' = 'Locker.ReEnterPasscode', 
	'Locker.ReEnterPasscodeToConfirm' = 'Locker.ReEnterPasscodeToConfirm', 
	'Locker.ResetFilters' = 'Locker.ResetFilters', 
	'Locker.ResetRequestSentExplanatory' = 'Locker.ResetRequestSentExplanatory', 
	'Locker.ResetRequestSent' = 'Locker.ResetRequestSent', 
	'Locker.Search' = 'Locker.Search', 
	'Locker.SearchPlaceholder' = 'Locker.SearchPlaceholder', 
	'Locker.SendResetRequest' = 'Locker.SendResetRequest', 
	'Locker.SendResetRequestExplanatory' = 'Locker.SendResetRequestExplanatory', 
	'Locker.SetupIsReady' = 'Locker.SetupIsReady', 
	'Locker.ShowFiles' = 'Locker.ShowFiles', 
	'Locker.ShowingResults' = 'Locker.ShowingResults', 
	'Locker.SignInWithBiometrics' = 'Locker.SignInWithBiometrics', 
	'Locker.SigninWithBiometricesExplanatory' = 'Locker.SigninWithBiometricesExplanatory', 
	'Locker.TypeFilter' = 'Locker.TypeFilter', 
	'Locker.Update' = 'Locker.Update', 
	'Locker.View' = 'Locker.View', 
	'Locker.Welcome' = 'Locker.Welcome', 
	'Locker.WelcomeExplanatory' = 'Locker.WelcomeExplanatory', 
	'Locker.YearFilter' = 'Locker.YearFilter', 
	'Locker.CreatePasscodeExplanatory' = 'Locker.CreatePasscodeExplanatory', 
	'LockerUnavailableExplanatory' = 'LockerUnavailableExplanatory', 
	'LockerUnavailable' = 'LockerUnavailable', 
	'Locker.SetupUnavailableTitle' = 'Locker.SetupUnavailableTitle', 
	'Locker.SetupUnavailable' = 'Locker.SetupUnavailable', 
	'Locker.ExitLocker' = 'Locker.ExitLocker', 
	'Locker.LockedOut' = 'Locker.LockedOut', 
	'Locker.GettingCredentials' = 'Locker.GettingCredentials', 
	'PeopleDirectory.BackToDirectory' = 'PeopleDirectory.BackToDirectory', 
	'PeopleDirectory.DownloadContact' = 'PeopleDirectory.DownloadContact', 
	'PeopleDirectory.NoResultsForX' = 'PeopleDirectory.NoResultsForX', 
	'PeopleDirectory.NobodyFound' = 'PeopleDirectory.NobodyFound', 
	'PeopleDirectory.People' = 'PeopleDirectory.People', 
	'PeopleDirectory.SearchForNameJob' = 'PeopleDirectory.SearchForNameJob', 
	'PeopleDirectory.See1Result' = 'PeopleDirectory.See1Result', 
	'PeopleDirectory.SeeXResults' = 'PeopleDirectory.SeeXResults', 
	'PeopleDirectory.ShowingResultFor' = 'PeopleDirectory.ShowingResultFor', 
	'PeopleDirectory.ShowingXResultsFor' = 'PeopleDirectory.ShowingXResultsFor', 
	'PeopleDirectory.XPeople' = 'PeopleDirectory.XPeople', 
	'PeopleDirectory.SearchUsers' = 'PeopleDirectory.SearchUsers', 
	'Onboarding.' = 'Onboarding.', 
	'Onboarding.AddMobile' = 'Onboarding.AddMobile', 
	'Onboarding.AgreeTermsOfUse' = 'Onboarding.AgreeTermsOfUse', 
	'Onboarding.AgreeTo' = 'Onboarding.AgreeTo', 
	'Onboarding.AlreadyCompletedRegistration' = 'Onboarding.AlreadyCompletedRegistration', 
	'Onboarding.AlreadyRegistered' = 'Onboarding.AlreadyRegistered', 
	'Onboarding.BackToLogin' = 'Onboarding.BackToLogin', 
	'Onboarding.BackToRecovery' = 'Onboarding.BackToRecovery', 
	'Onboarding.BackToRegistration' = 'Onboarding.BackToRegistration', 
	'Onboarding.BackToWorkspaceSelection' = 'Onboarding.BackToWorkspaceSelection', 
	'Onboarding.BrandLogo' = 'Onboarding.BrandLogo', 
	'Onboarding.ChangeWorkspace' = 'Onboarding.ChangeWorkspace', 
	'Onboarding.ChangeYourPassword' = 'Onboarding.ChangeYourPassword', 
	'Onboarding.ChooseNewPassword' = 'Onboarding.ChooseNewPassword', 
	'Onboarding.ChooseRecoveryMethod' = 'Onboarding.ChooseRecoveryMethod', 
	'Onboarding.ClickLinkInEmail' = 'Onboarding.ClickLinkInEmail', 
	'Onboarding.CompleteRegistration' = 'Onboarding.CompleteRegistration', 
	'Onboarding.ConfirmNewPassword' = 'Onboarding.ConfirmNewPassword', 
	'Onboarding.ContactSupportPassword' = 'Onboarding.ContactSupportPassword', 
	'Onboarding.CreateWorkspace' = 'Onboarding.CreateWorkspace', 
	'Onboarding.CurrentPassword' = 'Onboarding.CurrentPassword', 
	'Onboarding.CurrentPasswordIncorrect' = 'Onboarding.CurrentPasswordIncorrect', 
	'Onboarding.DetailsNotShared' = 'Onboarding.DetailsNotShared', 
	'Onboarding.DoThisLater' = 'Onboarding.DoThisLater', 
	'Onboarding.EnterCode' = 'Onboarding.EnterCode', 
	'Onboarding.EnterCodeSentViaText' = 'Onboarding.EnterCodeSentViaText', 
	'Onboarding.EnterCurrentPassword' = 'Onboarding.EnterCurrentPassword', 
	'Onboarding.EnterNewPassword' = 'Onboarding.EnterNewPassword', 
	'Onboarding.EnterOrgPassword' = 'Onboarding.EnterOrgPassword', 
	'Onboarding.EnterPasswordToReset' = 'Onboarding.EnterPasswordToReset', 
	'Onboarding.EnterTempPassword' = 'Onboarding.EnterTempPassword', 
	'Onboarding.EnterValidEmail' = 'Onboarding.EnterValidEmail', 
	'Onboarding.EnterValidPhone' = 'Onboarding.EnterValidPhone', 
	'Onboarding.EnterWorkspaceName' = 'Onboarding.EnterWorkspaceName', 
	'Onboarding.ErrorExternalProvider' = 'Onboarding.ErrorExternalProvider', 
	'Onboarding.ForgetPasswordReset' = 'Onboarding.ForgetPasswordReset', 
	'Onboarding.ForgotPassword' = 'Onboarding.ForgotPassword', 
	'Onboarding.GetStarted' = 'Onboarding.GetStarted', 
	'Onboarding.HaventSetupWorkspace' = 'Onboarding.HaventSetupWorkspace', 
	'Onboarding.IncorrectCode' = 'Onboarding.IncorrectCode', 
	'Onboarding.IssueAutoLogin' = 'Onboarding.IssueAutoLogin', 
	'Onboarding.LockedOut' = 'Onboarding.LockedOut', 
	'Onboarding.LockedOut5Minutes' = 'Onboarding.LockedOut5Minutes', 
	'Onboarding.LogInToYourWorkspace' = 'Onboarding.LogInToYourWorkspace', 
	'Onboarding.LogInWith' = 'Onboarding.LogInWith', 
	'Onboarding.Login' = 'Onboarding.Login', 
	'Onboarding.LoginFailed' = 'Onboarding.LoginFailed', 
	'Onboarding.LoginToYourAccount' = 'Onboarding.LoginToYourAccount', 
	'Onboarding.MobileNumberRemoved' = 'Onboarding.MobileNumberRemoved', 
	'Onboarding.MobileNumberUpdated' = 'Onboarding.MobileNumberUpdated', 
	'Onboarding.NeedToRegister' = 'Onboarding.NeedToRegister', 
	'Onboarding.NewHereGetStarted' = 'Onboarding.NewHereGetStarted', 
	'Onboarding.NewPassword' = 'Onboarding.NewPassword', 
	'Onboarding.NoRecoverySetup' = 'Onboarding.NoRecoverySetup', 
	'Onboarding.OrgWontSeeDetails' = 'Onboarding.OrgWontSeeDetails', 
	'Onboarding.OrganisationWontSeeNotShared' = 'Onboarding.OrganisationWontSeeNotShared', 
	'Onboarding.OrganisationInputInformation' = 'Onboarding.OrganisationInputInformation', 
	'Onboarding.PasswordCriteria' = 'Onboarding.PasswordCriteria', 
	'Onboarding.PasswordNotEmpty' = 'Onboarding.PasswordNotEmpty', 
	'Onboarding.PasswordRecoveryRemoved' = 'Onboarding.PasswordRecoveryRemoved', 
	'Onboarding.PasswordSameAsOld' = 'Onboarding.PasswordSameAsOld', 
	'Onboarding.PasswordSentReminder' = 'Onboarding.PasswordSentReminder', 
	'Onboarding.PasswordSentReminderSms' = 'Onboarding.PasswordSentReminderSms', 
	'Onboarding.PasswordsDontMatch' = 'Onboarding.PasswordsDontMatch', 
	'Onboarding.PhoneAlreadyAssociated' = 'Onboarding.PhoneAlreadyAssociated', 
	'Onboarding.PickNewPassword' = 'Onboarding.PickNewPassword', 
	'Onboarding.PleaseEnterWorkspace' = 'Onboarding.PleaseEnterWorkspace', 
	'Onboarding.PleaseUpdate' = 'Onboarding.PleaseUpdate', 
	'Onboarding.PopupRequiredLogin' = 'Onboarding.PopupRequiredLogin', 
	'Onboarding.RegisterGetStarted' = 'Onboarding.RegisterGetStarted', 
	'Onboarding.RegisterWithOrg' = 'Onboarding.RegisterWithOrg', 
	'Onboarding.RegisterYourAccount' = 'Onboarding.RegisterYourAccount', 
	'Onboarding.RegistrationSuccessful' = 'Onboarding.RegistrationSuccessful', 
	'Onboarding.RemoveEmail' = 'Onboarding.RemoveEmail', 
	'Onboarding.RemoveMobile' = 'Onboarding.RemoveMobile', 
	'Onboarding.RemoveRecovery' = 'Onboarding.RemoveRecovery', 
	'Onboarding.RemoveRecoveryConfirm' = 'Onboarding.RemoveRecoveryConfirm', 
	'Onboarding.RepeatPassword' = 'Onboarding.RepeatPassword', 
	'Onboarding.ResendEmailVerification' = 'Onboarding.ResendEmailVerification', 
	'Onboarding.ResendMobileVerification' = 'Onboarding.ResendMobileVerification', 
	'Onboarding.ResetLinkSent' = 'Onboarding.ResetLinkSent', 
	'Onboarding.ResetPassword' = 'Onboarding.ResetPassword', 
	'Onboarding.ResetPasswordSelect' = 'Onboarding.ResetPasswordSelect', 
	'Onboarding.SendMeEmail' = 'Onboarding.SendMeEmail', 
	'Onboarding.SendMeText' = 'Onboarding.SendMeText', 
	'Onboarding.SetPasswordRecovery' = 'Onboarding.SetPasswordRecovery', 
	'Onboarding.SetupWorkspace' = 'Onboarding.SetupWorkspace', 
	'Onboarding.StartExploring' = 'Onboarding.StartExploring', 
	'Onboarding.TempPassword' = 'Onboarding.TempPassword', 
	'Onboarding.TextMessageLinkWeSentYou' = 'Onboarding.TextMessageLinkWeSentYou', 
	'Onboarding.TsAndCs' = 'Onboarding.TsAndCs', 
	'Onboarding.TermsOfUse' = 'Onboarding.TermsOfUse', 
	'Onboarding.UnableToCompleteRegistration' = 'Onboarding.UnableToCompleteRegistration', 
	'Onboarding.UpdateMobile' = 'Onboarding.UpdateMobile', 
	'Onboarding.UpdateMobileNumber' = 'Onboarding.UpdateMobileNumber', 
	'Onboarding.UpdatePasswordRecovery' = 'Onboarding.UpdatePasswordRecovery', 
	'Onboarding.UpdateRequired' = 'Onboarding.UpdateRequired', 
	'Onboarding.UserNotFound' = 'Onboarding.UserNotFound', 
	'Onboarding.UserOrPasswordIncorrect' = 'Onboarding.UserOrPasswordIncorrect', 
	'Onboarding.UsernameNotEmpty' = 'Onboarding.UsernameNotEmpty', 
	'Onboarding.VerifyEmail' = 'Onboarding.VerifyEmail', 
	'Onboarding.VerifyEmailFailed' = 'Onboarding.VerifyEmailFailed', 
	'Onboarding.VerifyEmailFailedMessage' = 'Onboarding.VerifyEmailFailedMessage', 
	'Onboarding.VerifyEmailSuccess' = 'Onboarding.VerifyEmailSuccess', 
	'Onboarding.VerifyEmailSuccessMessage' = 'Onboarding.VerifyEmailSuccessMessage', 
	'Onboarding.WhatEmail' = 'Onboarding.WhatEmail', 
	'Onboarding.WhatPhone' = 'Onboarding.WhatPhone', 
	'Onboarding.WorkspaceName' = 'Onboarding.WorkspaceName', 
	'Onboarding.WorkspaceUnrecognised' = 'Onboarding.WorkspaceUnrecognised', 
	'Onboarding.YourWorkspaceName' = 'Onboarding.YourWorkspaceName', 
	'Onboarding.YoureIn' = 'Onboarding.YoureIn', 
	'Onboarding.PasswordChangeSuccess' = 'Onboarding.PasswordChangeSuccess', 
	'Month.April' = 'Month.April', 
	'Month.August' = 'Month.August', 
	'Month.December' = 'Month.December', 
	'Month.February' = 'Month.February', 
	'Month.January' = 'Month.January', 
	'Month.July' = 'Month.July', 
	'Month.June' = 'Month.June', 
	'Month.March' = 'Month.March', 
	'Month.May' = 'Month.May', 
	'Month.November' = 'Month.November', 
	'Month.October' = 'Month.October', 
	'Month.September' = 'Month.September', 
	'Month.Jan' = 'Month.Jan', 
	'Month.Feb' = 'Month.Feb', 
	'Month.Mar' = 'Month.Mar', 
	'Month.Apr' = 'Month.Apr', 
	'Month.Jun' = 'Month.Jun', 
	'Month.Jul' = 'Month.Jul', 
	'Month.Aug' = 'Month.Aug', 
	'Month.Sep' = 'Month.Sep', 
	'Month.Oct' = 'Month.Oct', 
	'Month.Nov' = 'Month.Nov', 
	'Month.Dec' = 'Month.Dec', 
	'Date.JustNow' = 'Date.JustNow', 
	'Date.Now' = 'Date.Now', 
	'Date.Sec' = 'Date.Sec', 
	'Date.Min' = 'Date.Min', 
	'Date.Mins' = 'Date.Mins', 
	'Date.Hour' = 'Date.Hour', 
	'Date.Hours' = 'Date.Hours', 
	'Date.Day' = 'Date.Day', 
	'Date.Days' = 'Date.Days', 
	'Date.Month' = 'Date.Month', 
	'Date.Months' = 'Date.Months', 
	'Date.Year' = 'Date.Year', 
	'Date.Years' = 'Date.Years', 
	'Date.Week' = 'Date.Week', 
	'Date.Weeks' = 'Date.Weeks', 
	'Passkeys.EditPasskey' = 'Passkeys.EditPasskey',
	'Passkeys.LastUsed' = 'Passkeys.LastUsed',
	'Passkeys.RemovePasskey' = 'Passkeys.RemovePasskey',
	'Passkeys.RemovePasskeyLogOut' = 'Passkeys.RemovePasskeyLogOut',
	'Passkeys.CreatePasskey' = 'Passkeys.CreatePasskey',
	'Passkeys.CodeAccepted' = 'Passkeys.CodeAccepted',	
	'Passkeys.CodeInvalid' = "Passkeys.CodeInvalid",
	'Passkeys.ManagePasskeys' = 'Passkeys.ManagePasskeys',
	'Passkeys.PasskeySettings' = 'Passkeys.PasskeySettings',
	'Passkeys.SignIn' = 'Passkeys.SignIn',
	'Passkeys.SignInPrompt' = 'Passkeys.SignInPrompt',
	'Passkeys.RemovePasskeyPrompt' = 'Passkeys.RemovePasskeyPrompt',
	'Passkeys.ShowIPAddress' = 'Passkeys.ShowIPAddress',
	'Passkeys.SignInCodeRequested' = 'Passkeys.SignInCodeRequested',
	'Passkeys.ContinuePrompt' = 'Passkeys.ContinuePrompt',
	'Passkeys.AccountReset' = 'Passkeys.AccountReset',
	'Passkeys.ResetRequested' = 'Passkeys.ResetRequested',
	'Passkeys.RecoveryRequest' = 'Passkeys.RecoveryRequest',
	'Passkeys.RecoveryRequestPrompt' = 'Passkeys.RecoveryRequestPrompt',
	'Passkeys.Verification' = 'Passkeys.Verification',
	'Passkeys.VerifyCode' = 'Passkeys.VerifyCode',
	'Passkeys.EmptyState' = 'Passkeys.EmptyState',
	'Profile.EditYourProfile' = 'Profile.EditYourProfile', 
	'Profile.JobRole' = 'Profile.JobRole', 
	'Profile.Department' = 'Profile.Department', 
	'Profile.FullSize' = 'Profile.FullSize', 
	'Profile.PhoneNumber' = 'Profile.PhoneNumber', 
	'Profile.ProfileImage' = 'Profile.ProfileImage', 
	'Profile.MyProfile' = 'Profile.MyProfile', 
	'Profile.PersonalisedImage' = 'Profile.PersonalisedImage', 
	'Profile.DefaultImage' = 'Profile.DefaultImage', 
	'Profile.EditProfile' = 'Profile.EditProfile', 
	'Profile.DisplayName' = 'Profile.DisplayName', 
	'Profile.UpdateSuccess' = 'Profile.UpdateSuccess', 
	'Profile.UpdateFail' = 'Profile.UpdateFail', 
	'Profile.DragPhoto' = 'Profile.DragPhoto', 
	'Profile.DropAnImage' = 'Profile.DropAnImage', 
	'Profile.AddPhoto' = 'Profile.AddPhoto', 
	'Profile.ChangePhoto' = 'Profile.ChangePhoto', 
	'Profile.UserNameNotFound' = 'Profile.UserNameNotFound', 
	'Profile.NoUsernameDefaultImage' = 'Profile.NoUsernameDefaultImage', 
	'Profile.UserDefaultImage' = 'Profile.UserDefaultImage', 
	'Profile.UserPersonalisedImage' = 'Profile.UserPersonalisedImage', 
	'Profile.ViewProfile' = 'Profile.ViewProfile', 
	'Profile.XProfileImage' = 'Profile.XProfileImage', 
	'Profile.ViewMyProfile' = 'Profile.ViewMyProfile', 
	'Profile.ViewFullSizeImage' = 'Profile.ViewFullSizeImage', 
	'Comments.CommentSingular' = 'Comments.CommentSingular', 
	'Comments.LikeSingular' = 'Comments.LikeSingular', 
	'Comments.AddComment' = 'Comments.AddComment', 
	'Comments.AddAComment' = 'Comments.AddAComment', 
	'Comments.AddACommentPlaceholder' = 'Comments.AddACommentPlaceholder', 
	'Comments.AreYouSureYouWantToRemoveThisComment' = 'Comments.AreYouSureYouWantToRemoveThisComment', 
	'Comments.BeTheFirstToComment' = 'Comments.BeTheFirstToComment', 
	'Comments.CannotLoadMoreReplies' = 'Comments.CannotLoadMoreReplies', 
	'Comments.CannotLoadNextComments' = 'Comments.CannotLoadNextComments', 
	'Comments.CannotLoadPreviousComments' = 'Comments.CannotLoadPreviousComments', 
	'Comments.Comment' = 'Comments.Comment', 
	'Comments.CommentOnThisPost' = 'Comments.CommentOnThisPost', 
	'Comments.CommentRemoved' = 'Comments.CommentRemoved', 
	'Comments.Comments' = 'Comments.Comments', 
	'Comments.FeedbackPlaceHolder' = 'Comments.FeedbackPlaceHolder', 
	'Comments.SendFeedback' = 'Comments.SendFeedback', 
	'Comments.YourFeedback' = 'Comments.YourFeedback', 
	'Comments.CommentTooLong' = 'Comments.CommentTooLong', 
	'Comments.DoYouWantToDiscardChangesToYourComment' = 'Comments.DoYouWantToDiscardChangesToYourComment', 
	'Comments.DoYouWantToDiscardYourComment' = 'Comments.DoYouWantToDiscardYourComment', 
	'Comments.EditComment' = 'Comments.EditComment', 
	'Comments.Edited' = 'Comments.Edited', 
	'Comments.EditReply' = 'Comments.EditReply', 
	'Comments.EditYourComment' = 'Comments.EditYourComment', 
	'Comments.HideReplies' = 'Comments.HideReplies', 
	'Comments.Like' = 'Comments.Like', 
	'Comments.Liked' = 'Comments.Liked', 
	'Comments.LikeThis' = 'Comments.LikeThis', 
	'Comments.LimitReached' = 'Comments.LimitReached', 
	'Comments.LoadMoreComments' = 'Comments.LoadMoreComments', 
	'Comments.Newest' = 'Comments.Newest', 
	'Comments.Oldest' = 'Comments.Oldest', 
	'Comments.PleaseShortenYourCommentTo5000CharactersOrLess' = 'Comments.PleaseShortenYourCommentTo5000CharactersOrLess', 
	'Comments.PostComment' = 'Comments.PostComment', 
	'Comments.RemoveComment' = 'Comments.RemoveComment', 
	'Comments.RemoveThisComment' = 'Comments.RemoveThisComment', 
	'Comments.Reply' = 'Comments.Reply', 
	'Comments.ReplyingTo' = 'Comments.ReplyingTo', 
	'Comments.ReplyToComment' = 'Comments.ReplyToComment', 
	'Comments.ReportAComment' = 'Comments.ReportAComment', 
	'Comments.ReportComment' = 'Comments.ReportComment', 
	'Comments.ReportedCommentsWillBeReviewedByAnAdministratorWhoWillTakeAction' = 'Comments.ReportedCommentsWillBeReviewedByAnAdministratorWhoWillTakeAction', 
	'Comments.ReportExplanatory' = 'Comments.ReportExplanatory', 
	'Comments.ReportInputPlaceholder' = 'Comments.ReportInputPlaceholder', 
	'Comments.ReportSuccessful' = 'Comments.ReportSuccessful', 
	'Comments.SaveComment' = 'Comments.SaveComment', 
	'Comments.Sending' = 'Comments.Sending', 
	'Comments.SendReport' = 'Comments.SendReport', 
	'Comments.ShowReplies' = 'Comments.ShowReplies', 
	'Comments.SortBy' = 'Comments.SortBy', 
	'Comments.TellUsWhyYouAreReportingTheComment' = 'Comments.TellUsWhyYouAreReportingTheComment', 
	'Comments.ThankYouForYourFeedback' = 'Comments.ThankYouForYourFeedback', 
	'Comments.ThisCommentHasBeenRemoved' = 'Comments.ThisCommentHasBeenRemoved', 
	'Comments.ViewCommentOptions' = 'Comments.ViewCommentOptions', 
	'Comments.View1Reply' = 'Comments.View1Reply', 
	'Comments.ViewMoreReplies' = 'Comments.ViewMoreReplies', 
	'Comments.ViewNextComments' = 'Comments.ViewNextComments', 
	'Comments.ViewNextReplies' = 'Comments.ViewNextReplies', 
	'Comments.ViewPreviousComments' = 'Comments.ViewPreviousComments', 
	'Comments.ViewPreviousReplies' = 'Comments.ViewPreviousReplies', 
	'Comments.ViewXReplies' = 'Comments.ViewXReplies', 
	'Comments.WeWereUnableToSendYourReport' = 'Comments.WeWereUnableToSendYourReport', 
	'Comments.WriteAComment' = 'Comments.WriteAComment', 
	'Comments.WriteAReply' = 'Comments.WriteAReply', 
	'Comments.XComments' = 'Comments.XComments', 
	'Comments.XLikes' = 'Comments.XLikes', 
	'Comments.Loading' = 'Comments.Loading', 
	'Comments.CommentUpdated' = 'Comments.CommentUpdated', 
	'Comments.CommentEditFailed' = 'Comments.CommentEditFailed', 
	'Comments.CommentSaved' = 'Comments.CommentSaved', 
	'Comments.CommentSaveFailed' = 'Comments.CommentSaveFailed', 
	'Comments.CommentDeleteFailed' = 'Comments.CommentDeleteFailed', 
	'Comments.RemovedCommentUsernamePlaceholder' = 'Comments.RemovedCommentUsernamePlaceholder', 
	'Comments.DiscardChanges' = 'Comments.DiscardChanges', 
	'Comments.DiscardComment' = 'Comments.DiscardComment', 
	'Comments.DiscardTheseChanges' = 'Comments.DiscardTheseChanges', 
	'Comments.DiscardThisComment' = 'Comments.DiscardThisComment', 
	'Notifications.ANewCompetitionHasBeenPosted' = 'Notifications.ANewCompetitionHasBeenPosted', 
	'Notifications.ANewEventHasBeenPosted' = 'Notifications.ANewEventHasBeenPosted', 
	'Notifications.ANewPostRequiresYourAttention' = 'Notifications.ANewPostRequiresYourAttention', 
	'Notifications.AreYouSureYouWantToCall' = 'Notifications.AreYouSureYouWantToCall', 
	'Notifications.Go' = 'Notifications.Go', 
	'Notifications.GoFindSomeInterestingPostsAndAddYourThoughts' = 'Notifications.GoFindSomeInterestingPostsAndAddYourThoughts', 
	'Notifications.Have' = 'Notifications.Have', 
	'Notifications.LikedYourComment' = 'Notifications.LikedYourComment', 
	'Notifications.LoadMoreNotifications' = 'Notifications.LoadMoreNotifications', 
	'Notifications.MentionedInComment' = 'Notifications.MentionedInComment', 
	'Notifications.MentionedYouInAComment' = 'Notifications.MentionedYouInAComment', 
	'Notifications.NewCompetition' = 'Notifications.NewCompetition', 
	'Notifications.NewEvent' = 'Notifications.NewEvent', 
	'Notifications.NewPost' = 'Notifications.NewPost', 
	'Notifications.NoNotifications' = 'Notifications.NoNotifications', 
	'Notifications.NoNotificationsFindSome' = 'Notifications.NoNotificationsFindSome', 
	'Notifications.OneLikedComment' = 'Notifications.OneLikedComment', 
	'Notifications.OneRepliedToComment' = 'Notifications.OneRepliedToComment', 
	'Notifications.RepliedToYourComment' = 'Notifications.RepliedToYourComment', 
	'Notifications.ThisIsWhereYoullFindYourNotifications' = 'Notifications.ThisIsWhereYoullFindYourNotifications', 
	'Notifications.SignInCodeRequest' = 'Notifications.SignInCodeRequest',
	'Notifications.UgcNotification' = 'Notifications.UgcNotification', 
	'Notifications.XLikedComment' = 'Notifications.XLikedComment', 
	'Notifications.XRepliedToComments' = 'Notifications.XRepliedToComments', 
	'Notifications.YouHaveBeenThankedBy' = 'Notifications.YouHaveBeenThankedBy', 
	'Notifications.YourNotifications' = 'Notifications.YourNotifications', 
	'Notifications.PasskeyResetRequested' = 'Notifications.PasskeyResetRequested',
	'Notifications.PlannerEventCreated' = 'Notifications.PlannerEventCreated', 
	'Notifications.PlannerEventCancelled' = 'Notifications.PlannerEventCancelled', 
	'Notifications.PlannerEventApproved' = 'Notifications.PlannerEventApproved', 
	'Notifications.PlannerEventDeclined' = 'Notifications.PlannerEventDeclined', 
	'General.Planner' = 'General.Planner', 
	'General.CreatedBy' = 'General.CreatedBy', 
	'Planner.AwaitingYourResponse' = 'Planner.AwaitingYourResponse', 
	'Planner.UpcomingEvents' = 'Planner.UpcomingEvents', 
	'Planner.Repeats' = 'Planner.Repeats', 
	'Planner.AreYouAttending' = 'Planner.AreYouAttending', 
	'Planner.EventRequiresMoreInfo' = 'Planner.EventRequiresMoreInfo', 
	'Planner.ThisEventRequiresAdminApproval' = 'Planner.ThisEventRequiresAdminApproval', 
	'Planner.AddToCalendar' = 'Planner.AddToCalendar', 
	'Planner.EditResponse' = 'Planner.EditResponse', 
	'Planner.Responded' = 'Planner.Responded', 
	'Planner.RespondedConcat' = 'Planner.RespondedConcat', 
	'Planner.Confirmed' = 'Planner.Confirmed', 
	'Planner.ConfirmedConcat' = 'Planner.ConfirmedConcat', 
	'Planner.NoUpcomingEvents' = 'Planner.NoUpcomingEvents', 
	'Planner.ViewDetails' = 'Planner.ViewDetails', 
	'Planner.ViewAll' = 'Planner.ViewAll', 
	'Planner.ResponseReceived' = 'Planner.ResponseReceived', 
	'Planner.YouAreNowAttending' = 'Planner.YouAreNowAttending', 
	'Planner.YouAreNotAttending' = 'Planner.YouAreNotAttending', 
	'Planner.RSVPAttending' = 'Planner.RSVPAttending', 
	'Planner.RSVPNotAttending' = 'Planner.RSVPNotAttending', 
	'Planner.ViewDiscarded' = 'Planner.ViewDiscarded', 
	'Planner.BackToPlanner' = 'Planner.BackToPlanner', 
	'Planner.ViewDiscardedEvents' = 'Planner.ViewDiscardedEvents', 
	'Planner.AwaitingResponse' = 'Planner.AwaitingResponse', 
	'Planner.Attending' = 'Planner.Attending', 
	'Planner.NotAttending' = 'Planner.NotAttending', 
	'Planner.BackToAll' = 'Planner.BackToAll', 
	'Planner.CustomTimeExplanatory' = 'Planner.CustomTimeExplanatory', 
	'Planner.Cancelled' = 'Planner.Cancelled', 
	'Planner.AlreadyAttending' = 'Planner.AlreadyAttending', 
	'Planner.EventFull' = 'Planner.EventFull', 
	'Planner.CannotChangeResponse' = 'Planner.CannotChangeResponse', 
	'Planner.Unknown' = 'Planner.Unknown', 
	'Planner.CannotChangeResponseLong' = 'Planner.CannotChangeResponseLong', 
	'Planner.EventFullSpacesLong' = 'Planner.EventFullSpacesLong', 
	'Planner.EventFullTimeLong' = 'Planner.EventFullTimeLong', 
	'Planner.AlreadyAttendingLong' = 'Planner.AlreadyAttendingLong', 
	'Planner.CancelledLong' = 'Planner.CancelledLong', 
	'Planner.EventStarted' = 'Planner.EventStarted', 
	'Planner.EventStartedLong' = 'Planner.EventStartedLong', 
	'Planner.EventFinished' = 'Planner.EventFinished', 
	'Planner.EventFinishedLong' = 'Planner.EventFinishedLong', 
	'Planner.DiscardedEvents' = 'Planner.DiscardedEvents', 
	'Planner.SelectedTime' = 'Planner.SelectedTime', 
	'Planner.TotalTime' = 'Planner.TotalTime', 
	'Planner.Gone' = 'Planner.Gone', 
	'Planner.Ended' = 'Planner.Ended', 
	'Planner.PendingApprovalLong' = 'Planner.PendingApprovalLong', 
	'Planner.PendingApproval' = 'Planner.PendingApproval', 
	'Planner.EventClosed' = 'Planner.EventClosed', 
	'Planner.EventClosedLong' = 'Planner.EventClosedLong', 
	'Errors.UnhandledError' = 'Errors.UnhandledError', 
	'Errors.Oops' = 'Errors.Oops', 
	'Errors.ABuildWithThisPackageNameAlreadyExists' = 'Errors.ABuildWithThisPackageNameAlreadyExists', 
	'Errors.AccountInvalid' = 'Errors.AccountInvalid', 
	'Errors.AccountLocked' = 'Errors.AccountLocked', 
	'Errors.AcknowledgementContentIsAtCapacity' = 'Errors.AcknowledgementContentIsAtCapacity', 
	'Errors.AgreeToTerms' = 'Errors.AgreeToTerms', 
	'Errors.AlreadyRegistered' = 'Errors.AlreadyRegistered', 
	'Errors.AutomaticLoginError' = 'Errors.AutomaticLoginError', 
	'Errors.CannotConvert0IntoXamarinFormsEasing' = 'Errors.CannotConvert0IntoXamarinFormsEasing', 
	'Errors.CannotUploadProfile' = 'Errors.CannotUploadProfile', 
	'Errors.ClipboardError' = 'Errors.ClipboardError', 
	'Errors.CommentDeleted' = 'Errors.CommentDeleted', 
	'Errors.ContentTemporarilyUnavailable' = 'Errors.ContentTemporarilyUnavailable', 
	'Errors.ContentUnavailable' = 'Errors.ContentUnavailable', 
	'Errors.CouldntUpdateProfilePicture' = 'Errors.CouldntUpdateProfilePicture', 
	'Errors.CountryCodeIsInvalid' = 'Errors.CountryCodeIsInvalid', 
	'Errors.EmailAddressIsInvalid' = 'Errors.EmailAddressIsInvalid', 
	'Errors.EmailAlreadyConfirmed' = 'Errors.EmailAlreadyConfirmed', 
	'Errors.EmailAlreadyInUseAsRecoveryMethodByAnotherUser' = 'Errors.EmailAlreadyInUseAsRecoveryMethodByAnotherUser', 
	'Errors.Error' = 'Errors.Error', 
	'Errors.ErrorFromServer' = 'Errors.ErrorFromServer', 
	'Errors.ErrorFromServerGone' = 'Errors.ErrorFromServerGone', 
	'Errors.FailedToUpdatePassword' = 'Errors.FailedToUpdatePassword', 
	'Errors.FormSaveError' = 'Errors.FormSaveError', 
	'Errors.GenericError' = 'Errors.GenericError', 
	'Errors.InvalidCountryCode' = 'Errors.InvalidCountryCode', 
	'Errors.InvalidCredentials' = 'Errors.InvalidCredentials', 
	'Errors.InvalidModel' = 'Errors.InvalidModel', 
	'Errors.InvalidUrl' = 'Errors.InvalidUrl', 
	'Errors.ItemKeyIsRequired' = 'Errors.ItemKeyIsRequired', 
	'Errors.NameTooLong' = 'Errors.NameTooLong',
	'Errors.NewPasswordCannotBeTheSameAsTheOldOne' = 'Errors.NewPasswordCannotBeTheSameAsTheOldOne', 
	'Errors.NoApps' = 'Errors.NoApps', 
	'Errors.NoContent' = 'Errors.NoContent', 
	'Errors.NoPermissionToOrgContent' = 'Errors.NoPermissionToOrgContent', 
	'Errors.NoPermission' = 'Errors.NoPermission', 
	'Errors.NoVppCodesAreAvailable' = 'Errors.NoVppCodesAreAvailable', 
	'Errors.NoVppKeywordExists' = 'Errors.NoVppKeywordExists', 
	'Errors.NotModifiedWithEmptyCacheShouldntHappen' = 'Errors.NotModifiedWithEmptyCacheShouldntHappen', 
	'Errors.OneTimePasswordExpired' = 'Errors.OneTimePasswordExpired', 
	'Errors.OneTimePasswordInvalid' = 'Errors.OneTimePasswordInvalid', 
	'Errors.OrgDoesNotExist' = 'Errors.OrgDoesNotExist', 
	'Errors.PasswordDoesntMeetRequirements' = 'Errors.PasswordDoesntMeetRequirements', 
	'Errors.PersonDoesNotExist' = 'Errors.PersonDoesNotExist', 
	'Errors.PhoneNumberAlreadyAssociatedWithThisAccount' = 'Errors.PhoneNumberAlreadyAssociatedWithThisAccount', 
	'Errors.PhoneNumberIsAlreadyInUse' = 'Errors.PhoneNumberIsAlreadyInUse', 
	'Errors.PhoneNumberIsInvalid' = 'Errors.PhoneNumberIsInvalid', 
	'Errors.PhoneNumberNotConfirmed' = 'Errors.PhoneNumberNotConfirmed', 
	'Errors.PleaseTryAgain' = 'Errors.PleaseTryAgain', 
	'Errors.ProfileCouldNotBeLoaded' = 'Errors.ProfileCouldNotBeLoaded', 
	'Errors.RecoveryMethodNotSetupForThisUser' = 'Errors.RecoveryMethodNotSetupForThisUser', 
	'Errors.RegisterPhone' = 'Errors.RegisterPhone', 
	'Errors.RegisterUserDetailsError' = 'Errors.RegisterUserDetailsError', 
	'Errors.RegisteringError' = 'Errors.RegisteringError', 
	'Errors.RegisteringPasswordError' = 'Errors.RegisteringPasswordError', 
	'Errors.RequestUri' = 'Errors.RequestUri', 
	'Errors.RequiresEmailDomainValidation' = 'Errors.RequiresEmailDomainValidation', 
	'Errors.SomethingHasGoneWrong' = 'Errors.SomethingHasGoneWrong', 
	'Errors.SorryGoogleLoginUnsupportedAtThisTime' = 'Errors.SorryGoogleLoginUnsupportedAtThisTime', 
	'Errors.SorryThisPageHasBeenRemovedAndCannotBeDisplayedPleaseSelectADifferentPageFromTheMenu' = 'Errors.SorryThisPageHasBeenRemovedAndCannotBeDisplayedPleaseSelectADifferentPageFromTheMenu', 
	'Errors.SorryUnableToLogInAtThisTime' = 'Errors.SorryUnableToLogInAtThisTime', 
	'Errors.SorryUnableToUpdateCommentsLikesAtThisTime' = 'Errors.SorryUnableToUpdateCommentsLikesAtThisTime', 
	'Errors.SorryWeWereUnableToUpdateYourPassword' = 'Errors.SorryWeWereUnableToUpdateYourPassword', 
	'Errors.ThisContentIsNotAvailableOfflinePleaseConnectAgainAndRetry' = 'Errors.ThisContentIsNotAvailableOfflinePleaseConnectAgainAndRetry', 
	'Errors.ThisPageIsNotCurrentlyAvailablePleaseTryAgainLaterIfTheProblemPersistsPleaseContactYourAppAdministrator' = 'Errors.ThisPageIsNotCurrentlyAvailablePleaseTryAgainLaterIfTheProblemPersistsPleaseContactYourAppAdministrator', 
	'Errors.ThisUserIsNoLongerAvailableInYourOrganization' = 'Errors.ThisUserIsNoLongerAvailableInYourOrganization', 
	'Errors.Timeout' = 'Errors.Timeout', 
	'Errors.UnableToResetPassword' = 'Errors.UnableToResetPassword', 
	'Errors.UnableToUpdateProfileAtThisTime' = 'Errors.UnableToUpdateProfileAtThisTime', 
	'Errors.Unauthorised' = 'Errors.Unauthorised', 
	'Errors.UnknownBuild' = 'Errors.UnknownBuild', 
	'Errors.UnknownDataErr' = 'Errors.UnknownDataErr', 
	'Errors.UnknownEmailDomain' = 'Errors.UnknownEmailDomain', 
	'Errors.UnknownType' = 'Errors.UnknownType', 
	'Errors.UnknownUser' = 'Errors.UnknownUser', 
	'Errors.UserInactive' = 'Errors.UserInactive', 
	'Errors.UserIsAlreadyRegistered' = 'Errors.UserIsAlreadyRegistered', 
	'Errors.UserIsNotInThisOrganisation' = 'Errors.UserIsNotInThisOrganisation', 
	'Errors.UserLockedOut' = 'Errors.UserLockedOut', 
	'Errors.UserLockedOutUntil' = 'Errors.UserLockedOutUntil', 
	'Errors.UserNoLongerInOrg' = 'Errors.UserNoLongerInOrg', 
	'Errors.UserNotOnboarded' = 'Errors.UserNotOnboarded', 
	'Errors.ValidationCodeIsInvalid' = 'Errors.ValidationCodeIsInvalid', 
	'Errors.ValidationErrors' = 'Errors.ValidationErrors', 
	'Errors.Failed' = 'Errors.Failed', 
	'Errors.ErrorVerifyingCode' = 'Errors.ErrorVerifyingCode', 
	'Errors.LockOutMessage' = 'Errors.LockOutMessage', 
	'Errors.FormNotValid' = 'Errors.FormNotValid', 
	'Errors.MaxFileCountReached' = 'Errors.MaxFileCountReached', 
	'Errors.CannotPlayVideo' = 'Errors.CannotPlayVideo', 
	'Search.SearchPlaceHolderConcat' = 'Search.SearchPlaceHolderConcat', 
	'Search.SearchPlaceHolder' = 'Search.SearchPlaceHolder', 
	'Seach.AllTime' = 'Seach.AllTime', 
	'Search.Last7Days' = 'Search.Last7Days', 
	'Search.Last30Days' = 'Search.Last30Days', 
	'Search.Last6Months' = 'Search.Last6Months', 
	'Search.ThisYear' = 'Search.ThisYear', 
	'Search.LastYear' = 'Search.LastYear', 
	'Search.ImagesOnly' = 'Search.ImagesOnly', 
	'Search.VideosOnly' = 'Search.VideosOnly', 
	'Search.FilesOnly' = 'Search.FilesOnly', 
	'Search.AudioOnly' = 'Search.AudioOnly', 
	'Search.WebOnly' = 'Search.WebOnly', 
	'Search.FeaturedImageForX' = 'Search.FeaturedImageForX', 
	'Search.FoundIn' = 'Search.FoundIn', 
	'Search.FoundInConcat' = 'Search.FoundInConcat', 
	'Search.Published' = 'Search.Published', 
	'Search.PublishedConcat' = 'Search.PublishedConcat', 
	'Search.Languages' = 'Search.Languages', 
	'Search.Type' = 'Search.Type', 
	'Search.ContentType' = 'Search.ContentType', 
	'Search.Results' = 'Search.Results', 
	'Search.ResultsConcat' = 'Search.ResultsConcat', 
	'Search.OneResult' = 'Search.OneResult', 
	'Search.Default' = 'Search.Default', 
	'Search.AppDefault' = 'Search.AppDefault', 
	'Search.Rules' = 'Search.Rules', 
	'Search.SearchTitlesOnly' = 'Search.SearchTitlesOnly', 
	'Search.NoResultsFound' = 'Search.NoResultsFound', 
	'Search.FoundInPlacesConcat' = 'Search.FoundInPlacesConcat', 
	'Search.TitleMatch' = 'Search.TitleMatch', 
	'Errors.CannotPlayInBrowser' = 'Errors.CannotPlayInBrowser', 
	'Errors.FileTypeMayNotBeSupported' = 'Errors.FileTypeMayNotBeSupported', 
	'Errors.RecommendedVideoTypes' = 'Errors.RecommendedVideoTypes', 
	'Countries.AC' = 'Countries.AC', 
	'Countries.AD' = 'Countries.AD', 
	'Countries.AE' = 'Countries.AE', 
	'Countries.AF' = 'Countries.AF', 
	'Countries.AG' = 'Countries.AG', 
	'Countries.AI' = 'Countries.AI', 
	'Countries.AL' = 'Countries.AL', 
	'Countries.AM' = 'Countries.AM', 
	'Countries.AO' = 'Countries.AO', 
	'Countries.AR' = 'Countries.AR', 
	'Countries.AS' = 'Countries.AS', 
	'Countries.AT' = 'Countries.AT', 
	'Countries.AU' = 'Countries.AU', 
	'Countries.AW' = 'Countries.AW', 
	'Countries.AX' = 'Countries.AX', 
	'Countries.AZ' = 'Countries.AZ', 
	'Countries.BA' = 'Countries.BA', 
	'Countries.BB' = 'Countries.BB', 
	'Countries.BD' = 'Countries.BD', 
	'Countries.BE' = 'Countries.BE', 
	'Countries.BF' = 'Countries.BF', 
	'Countries.BG' = 'Countries.BG', 
	'Countries.BH' = 'Countries.BH', 
	'Countries.BI' = 'Countries.BI', 
	'Countries.BJ' = 'Countries.BJ', 
	'Countries.BL' = 'Countries.BL', 
	'Countries.BM' = 'Countries.BM', 
	'Countries.BN' = 'Countries.BN', 
	'Countries.BO' = 'Countries.BO', 
	'Countries.BQ' = 'Countries.BQ', 
	'Countries.BR' = 'Countries.BR', 
	'Countries.BS' = 'Countries.BS', 
	'Countries.BT' = 'Countries.BT', 
	'Countries.BW' = 'Countries.BW', 
	'Countries.BY' = 'Countries.BY', 
	'Countries.BZ' = 'Countries.BZ', 
	'Countries.CA' = 'Countries.CA', 
	'Countries.CC' = 'Countries.CC', 
	'Countries.CD' = 'Countries.CD', 
	'Countries.CF' = 'Countries.CF', 
	'Countries.CG' = 'Countries.CG', 
	'Countries.CH' = 'Countries.CH', 
	'Countries.CI' = 'Countries.CI', 
	'Countries.CK' = 'Countries.CK', 
	'Countries.CL' = 'Countries.CL', 
	'Countries.CM' = 'Countries.CM', 
	'Countries.CN' = 'Countries.CN', 
	'Countries.CO' = 'Countries.CO', 
	'Countries.CR' = 'Countries.CR', 
	'Countries.CU' = 'Countries.CU', 
	'Countries.CV' = 'Countries.CV', 
	'Countries.CW' = 'Countries.CW', 
	'Countries.CX' = 'Countries.CX', 
	'Countries.CY' = 'Countries.CY', 
	'Countries.CZ' = 'Countries.CZ', 
	'Countries.DE' = 'Countries.DE', 
	'Countries.DJ' = 'Countries.DJ', 
	'Countries.DK' = 'Countries.DK', 
	'Countries.DM' = 'Countries.DM', 
	'Countries.DO' = 'Countries.DO', 
	'Countries.DZ' = 'Countries.DZ', 
	'Countries.EC' = 'Countries.EC', 
	'Countries.EE' = 'Countries.EE', 
	'Countries.EG' = 'Countries.EG', 
	'Countries.EH' = 'Countries.EH', 
	'Countries.ER' = 'Countries.ER', 
	'Countries.ES' = 'Countries.ES', 
	'Countries.ET' = 'Countries.ET', 
	'Countries.FI' = 'Countries.FI', 
	'Countries.FJ' = 'Countries.FJ', 
	'Countries.FK' = 'Countries.FK', 
	'Countries.FM' = 'Countries.FM', 
	'Countries.FO' = 'Countries.FO', 
	'Countries.FR' = 'Countries.FR', 
	'Countries.GA' = 'Countries.GA', 
	'Countries.GB' = 'Countries.GB', 
	'Countries.GD' = 'Countries.GD', 
	'Countries.GE' = 'Countries.GE', 
	'Countries.GF' = 'Countries.GF', 
	'Countries.GG' = 'Countries.GG', 
	'Countries.GH' = 'Countries.GH', 
	'Countries.GI' = 'Countries.GI', 
	'Countries.GL' = 'Countries.GL', 
	'Countries.GM' = 'Countries.GM', 
	'Countries.GN' = 'Countries.GN', 
	'Countries.GP' = 'Countries.GP', 
	'Countries.GQ' = 'Countries.GQ', 
	'Countries.GR' = 'Countries.GR', 
	'Countries.GT' = 'Countries.GT', 
	'Countries.GU' = 'Countries.GU', 
	'Countries.GW' = 'Countries.GW', 
	'Countries.GY' = 'Countries.GY', 
	'Countries.HK' = 'Countries.HK', 
	'Countries.HN' = 'Countries.HN', 
	'Countries.HR' = 'Countries.HR', 
	'Countries.HT' = 'Countries.HT', 
	'Countries.HU' = 'Countries.HU', 
	'Countries.ID' = 'Countries.ID', 
	'Countries.IE' = 'Countries.IE', 
	'Countries.IL' = 'Countries.IL', 
	'Countries.IM' = 'Countries.IM', 
	'Countries.IN' = 'Countries.IN', 
	'Countries.IO' = 'Countries.IO', 
	'Countries.IQ' = 'Countries.IQ', 
	'Countries.IR' = 'Countries.IR', 
	'Countries.IS' = 'Countries.IS', 
	'Countries.IT' = 'Countries.IT', 
	'Countries.JE' = 'Countries.JE', 
	'Countries.JM' = 'Countries.JM', 
	'Countries.JO' = 'Countries.JO', 
	'Countries.JP' = 'Countries.JP', 
	'Countries.KE' = 'Countries.KE', 
	'Countries.KG' = 'Countries.KG', 
	'Countries.KH' = 'Countries.KH', 
	'Countries.KI' = 'Countries.KI', 
	'Countries.KM' = 'Countries.KM', 
	'Countries.KN' = 'Countries.KN', 
	'Countries.KP' = 'Countries.KP', 
	'Countries.KR' = 'Countries.KR', 
	'Countries.KW' = 'Countries.KW', 
	'Countries.KY' = 'Countries.KY', 
	'Countries.KZ' = 'Countries.KZ', 
	'Countries.LA' = 'Countries.LA', 
	'Countries.LB' = 'Countries.LB', 
	'Countries.LC' = 'Countries.LC', 
	'Countries.LI' = 'Countries.LI', 
	'Countries.LK' = 'Countries.LK', 
	'Countries.LR' = 'Countries.LR', 
	'Countries.LS' = 'Countries.LS', 
	'Countries.LT' = 'Countries.LT', 
	'Countries.LU' = 'Countries.LU', 
	'Countries.LV' = 'Countries.LV', 
	'Countries.LY' = 'Countries.LY', 
	'Countries.MA' = 'Countries.MA', 
	'Countries.MC' = 'Countries.MC', 
	'Countries.MD' = 'Countries.MD', 
	'Countries.ME' = 'Countries.ME', 
	'Countries.MF' = 'Countries.MF', 
	'Countries.MG' = 'Countries.MG', 
	'Countries.MH' = 'Countries.MH', 
	'Countries.MK' = 'Countries.MK', 
	'Countries.ML' = 'Countries.ML', 
	'Countries.MM' = 'Countries.MM', 
	'Countries.MN' = 'Countries.MN', 
	'Countries.MO' = 'Countries.MO', 
	'Countries.MP' = 'Countries.MP', 
	'Countries.MQ' = 'Countries.MQ', 
	'Countries.MR' = 'Countries.MR', 
	'Countries.MS' = 'Countries.MS', 
	'Countries.MT' = 'Countries.MT', 
	'Countries.MU' = 'Countries.MU', 
	'Countries.MV' = 'Countries.MV', 
	'Countries.MW' = 'Countries.MW', 
	'Countries.MX' = 'Countries.MX', 
	'Countries.MY' = 'Countries.MY', 
	'Countries.MZ' = 'Countries.MZ', 
	'Countries.NA' = 'Countries.NA', 
	'Countries.NC' = 'Countries.NC', 
	'Countries.NE' = 'Countries.NE', 
	'Countries.NF' = 'Countries.NF', 
	'Countries.NG' = 'Countries.NG', 
	'Countries.NI' = 'Countries.NI', 
	'Countries.NL' = 'Countries.NL', 
	'Countries.NO' = 'Countries.NO', 
	'Countries.NP' = 'Countries.NP', 
	'Countries.NR' = 'Countries.NR', 
	'Countries.NU' = 'Countries.NU', 
	'Countries.NZ' = 'Countries.NZ', 
	'Countries.OM' = 'Countries.OM', 
	'Countries.PA' = 'Countries.PA', 
	'Countries.PE' = 'Countries.PE', 
	'Countries.PF' = 'Countries.PF', 
	'Countries.PG' = 'Countries.PG', 
	'Countries.PH' = 'Countries.PH', 
	'Countries.PK' = 'Countries.PK', 
	'Countries.PL' = 'Countries.PL', 
	'Countries.PM' = 'Countries.PM', 
	'Countries.PR' = 'Countries.PR', 
	'Countries.PS' = 'Countries.PS', 
	'Countries.PT' = 'Countries.PT', 
	'Countries.PW' = 'Countries.PW', 
	'Countries.PY' = 'Countries.PY', 
	'Countries.QA' = 'Countries.QA', 
	'Countries.RE' = 'Countries.RE', 
	'Countries.RO' = 'Countries.RO', 
	'Countries.RS' = 'Countries.RS', 
	'Countries.RU' = 'Countries.RU', 
	'Countries.RW' = 'Countries.RW', 
	'Countries.SA' = 'Countries.SA', 
	'Countries.SB' = 'Countries.SB', 
	'Countries.SC' = 'Countries.SC', 
	'Countries.SD' = 'Countries.SD', 
	'Countries.SE' = 'Countries.SE', 
	'Countries.SG' = 'Countries.SG', 
	'Countries.SH' = 'Countries.SH', 
	'Countries.SI' = 'Countries.SI', 
	'Countries.SJ' = 'Countries.SJ', 
	'Countries.SK' = 'Countries.SK', 
	'Countries.SL' = 'Countries.SL', 
	'Countries.SM' = 'Countries.SM', 
	'Countries.SN' = 'Countries.SN', 
	'Countries.SO' = 'Countries.SO', 
	'Countries.SR' = 'Countries.SR', 
	'Countries.SS' = 'Countries.SS', 
	'Countries.ST' = 'Countries.ST', 
	'Countries.SV' = 'Countries.SV', 
	'Countries.SX' = 'Countries.SX', 
	'Countries.SY' = 'Countries.SY', 
	'Countries.SZ' = 'Countries.SZ', 
	'Countries.TA' = 'Countries.TA', 
	'Countries.TC' = 'Countries.TC', 
	'Countries.TD' = 'Countries.TD', 
	'Countries.TG' = 'Countries.TG', 
	'Countries.TH' = 'Countries.TH', 
	'Countries.TJ' = 'Countries.TJ', 
	'Countries.TK' = 'Countries.TK', 
	'Countries.TL' = 'Countries.TL', 
	'Countries.TM' = 'Countries.TM', 
	'Countries.TN' = 'Countries.TN', 
	'Countries.TO' = 'Countries.TO', 
	'Countries.TR' = 'Countries.TR', 
	'Countries.TT' = 'Countries.TT', 
	'Countries.TV' = 'Countries.TV', 
	'Countries.TW' = 'Countries.TW', 
	'Countries.TZ' = 'Countries.TZ', 
	'Countries.UA' = 'Countries.UA', 
	'Countries.UG' = 'Countries.UG', 
	'Countries.US' = 'Countries.US', 
	'Countries.UY' = 'Countries.UY', 
	'Countries.UZ' = 'Countries.UZ', 
	'Countries.VA' = 'Countries.VA', 
	'Countries.VC' = 'Countries.VC', 
	'Countries.VE' = 'Countries.VE', 
	'Countries.VG' = 'Countries.VG', 
	'Countries.VI' = 'Countries.VI', 
	'Countries.VN' = 'Countries.VN', 
	'Countries.VU' = 'Countries.VU', 
	'Countries.WF' = 'Countries.WF', 
	'Countries.WS' = 'Countries.WS', 
	'Countries.XK' = 'Countries.XK', 
	'Countries.YE' = 'Countries.YE', 
	'Countries.YT' = 'Countries.YT', 
	'Countries.ZA' = 'Countries.ZA', 
	'Countries.ZM' = 'Countries.ZM', 
	'Countries.ZW' = 'Countries.ZW', 
	'Sections.Chat' = 'Sections.Chat', 
	'Chat.NoConversations' = 'Chat.NoConversations', 
	'Chat.NewChat' = 'Chat.NewChat', 
	'Chat.WriteAMessage' = 'Chat.WriteAMessage', 
	'Chat.SendMessage' = 'Chat.SendMessage', 
	'Chat.YourMessageCouldNotBeDelivered' = 'Chat.YourMessageCouldNotBeDelivered', 
	'Chat.SelectAConversationOrStartANewChat' = 'Chat.SelectAConversationOrStartANewChat', 
	'Chat.YouConcat' = 'Chat.YouConcat',
    getLocalString = "getLocalString", 
}

export default Localisation
